import { useEffect } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const Socket = new Echo({
  broadcaster: 'reverb',
  key: process.env.REACT_APP_ECHO_KEY,
  wsHost: process.env.REACT_APP_ECHO_HOST,
  wsPort: process.env.REACT_APP_ECHO_WS_PORT,
  // wssPort: import.meta.env.VITE_REVERB_PORT,
  forceTLS: Boolean(parseInt(process.env.REACT_APP_ECHO_FORCETLS || 0)),
  enabledTransports: (process.env.REACT_APP_ECHO_ENABLED_TRANSPORTS || 'ws').split(','),
});

window.SOCKET = Socket;

export const useSocket = (opts = {}, effects = []) => {
  useEffect(() => {
    Socket.channel(opts.channel).listenToAll((eventName, data) => {
      opts.onEvent({
        eventName,
        ...data,
      });
    });

    return () => {
      Socket.leave(opts.channel);
    };
  }, [...effects]);

  return {};
};
